import(/* webpackMode: "eager" */ "/vercel/path0/app/page.js");
